import React from 'react'
import LoginBanner from '../LoginBanner'
import classes from "./LoginHome.module.scss"
// import Logo from "../../../assets/images/logo.png"
import SquareButton from '../../../components/Buttons/SquareButton/SquareButton'
import { NavLink } from 'react-router-dom'
import * as r from "../../../constants/routes";
import { useTranslation } from 'react-i18next';

// Componente da Tela de escolha de login (Usuário ou Admin)
const LoginHome = () => {
  const { t } = useTranslation();

  // Rota de login
  const adminRoute = r.R_A_LOGIN;
  const userRoute = r.R_U_LOGIN;

  return (
    <div className={classes.HomeContainer}>
      <div className={classes.HomeBanner}>
        <LoginBanner />
      </div>
      <div className={classes.HomeForm}>
        <img src={"/new_logo_color.svg"} alt="Logo" className={classes.Logo} />
        <p className={classes.Subtitle}>{t("global.choose_how_you_want_to_continue")}</p>
        <div className={classes.HomeButton}>
          <NavLink to={userRoute} >
            <SquareButton
              text={"global.i_am_a_user"}
              title={"global.press_to_enter"}

              className={classes.UserButton}
            />
          </NavLink>
          <NavLink to={adminRoute} >
            <SquareButton
              text={"global.i_am_admin"}
              title={"global.press_to_enter"}
              btnLight
              className={classes.AdminButton}
            />
          </NavLink>
        </div>
      </div>
    </div>
  )
}

export default LoginHome
